import { Flex, Box, Text } from '@chakra-ui/core'
import OptimizedGroupsTree from 'components/CommonComponents/OptimizedGroupsTree'
import { SelectionMode } from 'components/CommonComponents/OptimizedGroupsTree/hooks/useSelection'
import { PreviewAvatarsList } from 'components/CommonComponents/PreviewList'
import useLocaleText from 'components/useLocaleText'
import colors from 'constants/colors'
import { RootState } from 'constants/interfaces'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { Users, Folder } from 'lucide-react'
import React from 'react'
import { useSelector } from 'react-redux'

interface UpdateUserGroupsProps {
  initialSelectedIds: string[]
  onSelectionChange: (selectedIds: string[]) => void
}

export const GroupsForm: React.FC<UpdateUserGroupsProps> = ({ initialSelectedIds, onSelectionChange }) => {
  const { windowHeight } = useWindowDimensions()

  const theme = useSelector((state: RootState) => state.general.theme)
  const { groups } = useSelector((state: RootState) => state.config.config)
  const listHeight = windowHeight * 0.5

  const admin_add_groups_description = useLocaleText('admin_add_groups_description')
  const groups_title = useLocaleText('groups')

  return (
    <>
      <Box border={`1px solid ${colors.greyBorder}`} borderRadius="10px" p="10px">
        <Flex alignItems="center" style={{ columnGap: '10px' }}>
          <Users size={88} strokeWidth={2.5} color={theme?.elementsColor} />
          <Flex alignItems="left" flexDir="column" justifyContent="center" style={{ rowGap: '5px' }}>
            <Text fontSize="14px">{admin_add_groups_description}</Text>
            <Flex alignItems="center" justifyContent="space-between" style={{ columnGap: '10px' }}>
              <PreviewAvatarsList
                icon={Folder}
                label={groups_title}
                items={initialSelectedIds.map((id) => ({
                  name: groups[id]?.name || '',
                }))}
                isGroup
                max={5}
              />
            </Flex>
          </Flex>
        </Flex>

        <OptimizedGroupsTree
          groups={groups}
          allowedGroups={Object.keys(groups)}
          showSearch
          listHeight={listHeight}
          initialSelectedIds={initialSelectedIds}
          selectionMode={SelectionMode.GROUP_PRIORITY}
          onSelectionChange={onSelectionChange}
        />
      </Box>
    </>
  )
}
